import { ContactForm } from "../components/ContactForm";
import { Mail, MapPin, Calendar } from "lucide-react";

export default function Contact() {
  return (
    <div data-testid="contact-page">
      <section className="border-b-2 border-[#1A1A18]">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16 md:py-24">
          <div className="font-mono-label text-[#4A7A3D] mb-3">Contact</div>
          <h1 className="font-display text-5xl md:text-7xl lg:text-8xl leading-[0.95]">Écris-nous.</h1>
          <p className="font-quote text-2xl md:text-3xl text-[#4B4B48] mt-6 leading-snug max-w-3xl">
            « Une question, une remarque, une proposition de tribune ou une invitation à débattre&nbsp;? Nous lisons et répondons à chaque message. »
          </p>
        </div>
      </section>

      <section className="border-b border-[#E0D8CE]">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16 grid lg:grid-cols-12 gap-12">
          <aside className="lg:col-span-4 space-y-8">
            <div className="border-l-4 border-[#4A7A3D] pl-4">
              <div className="font-mono-label text-[#4A7A3D] mb-1 flex items-center gap-2"><Mail size={14} /> Email rédaction</div>
              <a href="mailto:contact@rwanabizinlega.mu" className="font-display text-2xl hover:text-[#4A7A3D]">contact@rwanabizinlega.mu</a>
            </div>
            <div className="border-l-4 border-[#C4944A] pl-4">
              <div className="font-mono-label text-[#C4944A] mb-1 flex items-center gap-2"><MapPin size={14} /> Localisation</div>
              <div className="font-display text-xl">Île Maurice<br /><span className="text-base text-[#4B4B48]">Océan Indien</span></div>
            </div>
            <div className="border-l-4 border-[#8FAF82] pl-4">
              <div className="font-mono-label text-[#4A7A3D] mb-1 flex items-center gap-2"><Calendar size={14} /> Délai de réponse</div>
              <div className="font-display text-xl">2 à 5 jours ouvrés</div>
            </div>
            <p className="text-sm text-[#4B4B48] leading-relaxed pt-4 border-t border-[#E0D8CE]">
              Pour les demandes de presse, indique-le dans le sujet du message. Pour proposer un article ou une tribune, joins-nous un résumé de 5-10 lignes.
            </p>
          </aside>

          <div className="lg:col-span-8">
            <ContactForm variant="light" />
          </div>
        </div>
      </section>
    </div>
  );
}
